import React from 'react';

import {Components as Layout} from 'layout';
import {Components as Buttons} from 'buttons';

export interface Props {
    onMassGenerateProtocols(): void;
    massGenerateInProgress: boolean;
}

class MassGenerateProtocols extends React.PureComponent<Props> {
    render(): React.ReactNode {
        const {onMassGenerateProtocols, massGenerateInProgress} = this.props;

        return (
            <Layout.Panel>
                <Layout.LoaderWrapper showLoader={massGenerateInProgress}>
                    <div className="row">
                        <div className="col-12 mt-2 mb-3">
                            <strong className="d-block">
                                Hromadné generování protokolů
                            </strong>
                        </div>

                        <div className="col-12 mt-2">
                            <Buttons.Button
                                fullWidth
                                importance="primary"
                                type="button"
                                onClick={onMassGenerateProtocols}
                                disabled={massGenerateInProgress}
                            >
                                Generovat protokoly
                            </Buttons.Button>
                        </div>
                    </div>
                </Layout.LoaderWrapper>
            </Layout.Panel>
        );
    }
}


export default MassGenerateProtocols;
